export const dictionarySideBar = [
  {
    title: "Поиск по словарю",
    to: { name: "search" },
    iconName: "SearchIcon",
  },
];

export function getdictionarySideBar(name) {
  return dictionarySideBar.find((si) => si.name === name);
}
